"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AdobeSocialColorLight = _interopRequireDefault(require("@react/react-spectrum/Icon/AdobeSocialColorLight"));
var _CircleExperienceCloud = _interopRequireDefault(require("@exc/brand-icons/brand/CircleExperienceCloud.svg"));
var AnnouncementSelectors = _interopRequireWildcard(require("../../store/reducers/AnnouncementReducer"));
var _store = _interopRequireDefault(require("../../store/store"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const SolutionIcon = props => {
  const {
    product
  } = props;
  const userEntitlements = AnnouncementSelectors.getUserEntitlements(_store.default.getState());
  //Show default icon ExerienceCloud for announcement and notifications
  let productIcon = /*#__PURE__*/_react.default.createElement("img", {
    alt: product,
    src: _CircleExperienceCloud.default
  });
  for (const userEntitlement of userEntitlements) {
    let skip = false;
    if (product === userEntitlement.name || product === userEntitlement.longName && !skip && userEntitlement.functionalIconUrl) {
      skip = true;
      productIcon = /*#__PURE__*/_react.default.createElement("img", {
        alt: userEntitlement.name,
        src: userEntitlement.functionalIconUrl
      });
    }
  }
  //TODO remove once Social Product is deprecated
  if (product === 'Social') {
    productIcon = /*#__PURE__*/_react.default.createElement(_AdobeSocialColorLight.default, {
      className: "pulse-announcement-solution-icon",
      size: "L"
    });
  }
  return productIcon;
};
var _default = SolutionIcon;
exports.default = _default;